import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import { IClientTileProps } from 'interfaces/Dashboard/IClientTileProps';
import StatTile from '../../../components/common/StatTile';

const ClientOnTimeReportingTile = ({clientReference, limsDatabase}: IClientTileProps) => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getClientOnTimeReporting } = DashboardApis();

  useEffect(() => {
    getClientOnTimeReporting(clientReference, limsDatabase)
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getClientOnTimeReporting, clientReference, limsDatabase]);

  return (
    <StatTile
      label="On Time Reporting"
      value={value !== null ? value.toFixed(2) : '-'}
      suffix="%"
      loading={loading}
      error={error}
    />
  );
};

export default ClientOnTimeReportingTile;